<flx-modal
  [dismissible]="true"
  [contentClass]="'flex flex-col h-[calc(100%-80px)]'"
  (dismiss)="hideModal.emit()"
  class="flx-ds large h-full w-full"
>
  <div
    class="flx-modal-title"
    flxModalHeaderTitle
  >
    Runtime Exception
  </div>
  <div class="flx-modal-body">
    @if (context()) {
      <flx-exception-details-content
        [processException]="$safeNavigationMigration(context()?.processException)"
        [applicationDetails]="$safeNavigationMigration(context()?.applicationDetails)"
        [loading]="$safeNavigationMigration(context()?.loading)"
        class="h-full"
      ></flx-exception-details-content>
    }
  </div>
</flx-modal>
